import React from 'react';
import { DataForDesignDrawingsManifold } from '../../designs/data-for-design-drawings/dataForDesignDrawingsResponse';
import { RoomRow } from './templates/RoomRow';

type Props = {
  manifold: DataForDesignDrawingsManifold;
};
export const FloorCoveringRow = ({ manifold }: Props) => {
  return <RoomRow name="Floor Covering" manifold={manifold} getValue={room => room.floorCoveringName} />;
};
